import gql from 'graphql-tag';

export const FRAGMENT_SECURITIES_COMPANY = gql`
  fragment securitiesCompany on IPOSecuritiesCompany {
    name
    isLead
    affiliateUrl
  }
`;
